import useLazyQuery from 'api/hooks/useLazyQuery';
import permissions from 'api/Apollo/permissions';

import { GET_SAMPLE_EVENT } from './sample-event-query-builder';

export default function useLazyQuerySampleEvent({ ...options } = {}) {
  const [executeQuery, { data, ...rest }] = useLazyQuery(GET_SAMPLE_EVENT, {
    context: { permission: permissions.readSampleEvents },
    fetchPolicy: 'network-only',
    ...options,
  });

  const fetchSampleEvent = id => executeQuery({ variables: { id } });

  return [fetchSampleEvent, { sampleEvent: data?.sampleEvent || null, ...rest }];
}
